<template>
    <a-modal
    v-model="visible"
    width="1100px"
    height="80%"
    title="查看回单"
    :footer="null"
    centered
    class="chooseAddress"
    @ok="confirm"
  >
    <div v-if="imageList.length > 0" class="imgBox">
      <div v-if="addressFlag" class="selectBox">
        <span>目的地</span>
        <a-select v-model="address" class="selectStyle" @change="handleChange">
          <a-select-option v-for="(item, i) in imageList" :key="item.odrNo" :value="i">
            {{item.endFullAddress}}
          </a-select-option>
        </a-select>
      </div>
      <div ref="imageDiv" class="imageStyle">
        <receipt-image
          :url-list="imageList[address].receiptUrls"
          class="receipt-image"
        />
      </div>
    </div>
  </a-modal>
</template>

<script>
import image1 from '@/assets/img/preview.png'
import image2 from '@/assets/img/preview-nine.png'
import ReceiptImage from './ReceiptImage.vue';

export default {
  components: {
    ReceiptImage,
  },
  data(){
    return {
      visible: false,
      address: 0,
      addressFlag: true, // 是否有多个目的地
      imgList: [image1, image2],
      image: image1,
      rotate: 0,
      zoom: 1,
      index: 0,
      srcList: [],
      imageList: []
    }
  },
  computed: {
  },
  methods: {
    confirm(){

    },
    show(data){
      this.imageList = data
      this.visible = true
      if(this.imageList.length > 1)
        this.addressFlag = true
        else 
        this.addressFlag = false
    },
    handleChange() {
    },
    rotateImage(data){
      if(data) this.rotate += 90
        else 
        this.rotate -= 90

      this.$refs.imageItem.style.transform = `rotateZ(${this.rotate}deg)`
      if((this.rotate / 90) % 2 === 0){
        this.$refs.imageItem.style.width = `${this.$refs.imageDiv.clientWidth}px`
      } else {
        this.$refs.imageItem.style.width = `${this.$refs.imageDiv.clientHeight}px`
      }
    },
    nextOne(data){
      if(data){
        this.index += 1
        if(this.index > this.imgList.length - 1){
          this.index = 0
        }
      } else {
        this.index -= 1
        if(this.index < 0){
          this.index = this.imgList.length - 1
        }
      }
      this.image = this.imgList[this.index]
    }
  }
}
</script>
<style lang="less" scoped>
.imgBox{
  height: 100%;
  .selectStyle{
    width: 400px;
    margin-left: 16px;
  }
  .imageStyle{
    text-align: center;
    position: relative;
    background-color: #F6F6F6;
    overflow: hidden;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
    height: calc(100% - 80px);
    .receipt-image{
      width: 100%;
    }
  }
  .imgStyle{
    max-width: 100%;
    max-height: 100%;
  }
}
::v-deep .ant-modal-content{
  height: 100%;
}
::v-deep .ant-modal-body{
  height: calc(100% - 55px);
}
::v-deep .el-image-viewer__canvas{
  display: block !important;
}
</style>